// @ts-check

import type { Action } from "./actions";
import {
  handleAnimations,
  initialiseAnimations,
  setIframeSizes,
} from "./animations";
import {
  addTricodeRunners,
  interactiveCode,
  runInteractiveCode,
} from "./execute";
import { initialisePlayer } from "./player";
import { createTypewriters, type TypewriterInfo } from "./typewriter";

declare global {
  interface Window {
    fragments: Array<
      Array<{
        tracks: Array<{ urls: string[]; time: number }>;
        actions: Array<Action>;
        tn: string;
      }>
    >;
    group: number;
    __revealPaused?: boolean;
    __revealFragment?: HTMLDivElement;
    __codeRunner: {};
    __telemetry(type: string, data?: any);
    showTab(family: string, name: string);
  }

  interface Element {
    __runner(): void;
    __applyTypeWriter(
      target: Element,
      index: number,
      replacement: string
    ): void;
    __typewriterType(
      lineIndex: number,
      process: { run: boolean; speed: number; id: number },
      index: number,
      highlightedText: string,
      replacement: string
    ): void;
    __typewriterClear(lineIndex: number, replacement: string): void;
    __typewriterFlush(
      lineIndex: number,
      replacement: string,
      highlightedText: string
    ): void;
    __typewriter: {
      [index: number]: Element;
    };
    __parsedTypewriter: TypewriterInfo;
  }
}

export * from "./animations";
export * from "./player";
export * from "./screen";

function handleFocus() {
  window.parent?.__telemetry?.("focus");
}

function handleBlur() {
  window.parent?.__telemetry?.("blur");
}

export function beforeInitialise() {
  interactiveCode();

  window.addEventListener("focus", handleFocus);
  window.addEventListener("blur", handleBlur);

  Reveal.addEventListener("slidechanged", function (event) {
    // event.previousSlide, event.currentSlide, event.indexh, event.indexv
    runInteractiveCode();
  });
}

export function afterInitialise() {
  createTypewriters();
  runInteractiveCode();
  setIframeSizes();
  initialisePlayer();
  initialiseAnimations();
  handleAnimations();
  addTricodeRunners();
}
